<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.08.02</b> - Новые возможности, исправления и оптимизация</p>
    <div class="ml-5 pb-4 text-orange-400">
      <div class="font-bold mt-2">Новые возможности</div>
      <ul class="ml-4 list-disc">
        <li>
          Добавлено увольнение героев — теперь вы можете отпускать героев из своего состава за
          Пыльцу фей.
        </li>
        <li>В меню настроек добавлен виджет для活 активации реферальных кодов.</li>
        <li>
          Добавлены уведомления о противниках в Таверне, чтобы вы знали, когда вас кто-то вызвал на
          бой.
        </li>
        <li>
          Добавлены префиксы предметов «Удачливый» и «Неудачливый», влияющие на поиск добычи вашим
          отрядом.
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>Исправлена поломка подсказок после сброса атрибутов героя.</li>
        <li>Исправлена прокрутка чата вниз при получении длинных сообщений.</li>
        <li>Исправлены графические сбои в Магазине и в тексте плиток Пещер.</li>
        <li>
          Исправлено скрытое подавление ошибок атаки в Таверне — теперь вы увидите, почему атака
          недоступна.
        </li>
        <li>Исправлена периодически некорректная запись журналов боёв в Таверне.</li>
      </ul>

      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>
          Улучшены подсказки по атрибутам с более понятным отображением вторичных характеристик.
        </li>
        <li>Улучшены экран противников в Таверне и экран подготовки к атаке.</li>
        <li>Нажмите CTRL+SHIFT+U, чтобы включить или выключить интерфейс для чистых скриншотов.</li>
        <li>Феи теперь затемнены, чтобы меньше отвлекать внимание.</li>
        <li>Окно Пыльцы фей теперь полностью переведено.</li>
        <li>Различные улучшения экрана сборок героев, меню типов матчей Арены и обзора матча.</li>
      </ul>

      <div class="font-bold mt-2">Производительность</div>
      <ul class="ml-4 list-disc">
        <li>
          Снижен общий вес страницы благодаря спрайт-листам в формате WebP для более быстрой
          загрузки.
        </li>
        <li>
          Аудиофайлы теперь загружаются по мере необходимости, а не все сразу, что сокращает время
          первоначальной загрузки.
        </li>
        <li>
          Убрано затратное кеширование изображений в Магазине и других видах на канвасе, что снижает
          расход памяти и подтормаживания.
        </li>
        <li>
          Улучшено переиспользование объектов в виде плиток Пещер для более плавного исследования.
        </li>
        <li>
          Сортировка ролей ИИ героев, платежи и другие системы переведены на более быстрый и
          надёжный серверный конвейер.
        </li>
      </ul>
    </div>
  </div>
</template>
